import { Component, ElementRef, ViewChild } from '@angular/core';
import { sendOtpDto } from '../shared/model/sendOtp-dto';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { NgOtpInputComponent } from 'ng-otp-input';
import { AppUsersDto } from '../shared/model/app-users-dto';
import { firstValueFrom, Observable, Subscription, take } from 'rxjs';
import { ThemeService } from '../shared/service/colourTheme.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../auth/auth.service';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../shared/service/logged-in-user.service';
import { CommonService } from '../shared/service/common.service';
import { ToastrService } from 'ngx-toastr';
import { DOMAIN_CONFIG } from 'domain-config';
import { Images } from '../shared/utils/image-enum';
import { customEmailValidator } from '../auth/signin/signin.component';
import { HttpStatusCode } from '@angular/common/http';
import { AdminService } from '../admin/admin.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-user-verification',
    templateUrl: './user-verification.component.html',
    styleUrls: ['./user-verification.component.scss'],
    standalone: false
})
export class UserVerificationComponent {
  enableVerifyAndContinue: boolean;
  enteredMobileNo: number;
  sendOtpDto: sendOtpDto = new sendOtpDto();
  termsAndConditionModal: boolean;
  ModalHeading: string;
  @ViewChild('otpInput', { read: ElementRef }) otpInput: ElementRef;
  @ViewChild('otpInput') otpInputRef: NgOtpInputComponent;
  contactNumberLength: number;
  passcode: any;
  loginUser: AppUsersDto;
  theme: boolean = false;
  resetPasswordForm: FormGroup;
  confirmpassword: string;
  jsonDecodedData:any;
  inviteToken: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      color: 'black',
      background: 'transparent',
      // 'width': '40px',
      height: '36px',
    },
  };

  addPasswordForm: boolean = false;
  constructor(
    private readonly toaster: ToastrService,
    private readonly router: Router,
    public readonly service: CommonService,
    private readonly _formBuilder: FormBuilder,
    private readonly loggedInUserService: LoggedInUserService,
    private readonly _authService: AuthService,
    private readonly titleService: Title,
    private readonly route: ActivatedRoute,
    public readonly themeService: ThemeService,
    private readonly _adminService: AdminService,
  ) {
    this.titleService.setTitle(`${service.Enums.BRAND_NAME} || Sign-in`);
    let currentDomain = window.location.hostname;
    this.currentDomain = DOMAIN_CONFIG[currentDomain]?.ssoLoginEnabled;
  }
  currentDomain: boolean = false;
  timeLeft: number = 30;
  intervalId: number;
  loading: boolean;
  timer$: Observable<number> = new Observable((observer) => {
    this.intervalId = window.setInterval(() => {
      this.timeLeft--;
      observer.next(this.timeLeft);
      if (this.timeLeft <= 0) {
        observer.complete();
      }
    }, 1000);

    return () => {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    };
  });
  timerSubscription?: Subscription;

  public get Images() {
    return {
      ...Images,
      FRACTAL_LOGO: environment.brand.logoUrl,
      IQIGAI_AI_LOGO: environment.brand.logoUrl,
      IQIGAI_LOGO: environment.brand.chatLogoUrl,
      LOGO_NEW_HEADER: environment.brand.headerLogoUrl,
    } as typeof Images;
  }

  private readonly PADDING_KEY = 'f360';
  newUser: boolean = false; // to show registration form
  ssoUserDetails: any; // Contains the user's information from the SSO login

  registrationForm: FormGroup;
  profileForm: FormGroup;
  showImageForValidEmail = false;
  enableStepEmail: boolean = false;
  enteredEmail: string = '';
  signUpVisible = false;
  signUpForm: FormGroup;
  setPasswordForm: FormGroup;
  forgotPasswordFormState: boolean = false;
  ngOnInit() {
    this.theme = this.themeService.isBlueTheme();
    this.bas64Decode();
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    } else {
      const errors = form.get('confirmPassword')?.errors;
      if (errors && errors['passwordMismatch']) {
        delete errors['passwordMismatch'];
        if (Object.keys(errors).length === 0) {
          form.get('confirmPassword')?.setErrors(null);
        }
      }
    }

    return null;
  }

  prefillForm() {
    // Pre-fill the registration form if user data is available
    if (this.ssoUserDetails) {
      this.registrationForm.patchValue({
        email: this.ssoUserDetails?.email || '',
        mobileNumber: this.ssoUserDetails?.mobileNumber || '',
        name: this.ssoUserDetails?.name || '',
      });
    }
    this.loading = false;
  }

  basicFormValidation() {
    this.profileForm = this._formBuilder.group({
      email: [
        '',
        [Validators.required, Validators.email, customEmailValidator],
      ],
      phoneCode: ['+91', Validators.required],
      mobileNumber: ['', [Validators.required, Validators.minLength(10)]],
      // password: ['', [Validators.required]],
    });
  }

  checkValidEmail(emailValue: string) {
    if (!this.profileForm.get('email').hasError('invalidEmail') && emailValue) {
      this.showImageForValidEmail = true;
    } else {
      this.showImageForValidEmail = false;
    }
  }

  contactNumberLengthForReset: number;
  contactNumberLengthForSignup: number;
  getContactLength(event: any) {
    const value = event.target.value;

    // If any alphabet exists, clear entire input
    if (/[a-zA-Z]/.test(value)) {
      event.target.value = '';
      this.signUpForm.get('mobileNumber')?.setValue('', { emitEvent: false });
      this.contactNumberLength = 0;
      return;
    }

    // Allow only digits (numbers)
    const cleaned = value.replace(/[^0-9]/g, '');

    if (value !== cleaned) {
      event.target.value = cleaned;
      this.signUpForm
        .get('mobileNumber')
        ?.setValue(cleaned, { emitEvent: false });
    }

    this.contactNumberLength = cleaned.length;
  }

  getContactLengthForReset(event: any) {
    this.contactNumberLengthForReset = event.target.value.length;
  }

  getContactLengthForSignup(event: any) {
    this.contactNumberLengthForSignup = event.target.value.length;
  }

  startTimer() {
    if (!this.timerSubscription || this.timerSubscription.closed) {
      this.timeLeft = 30;
      this.timerSubscription = this.timer$.pipe(take(30)).subscribe();
    }
  }

  onChangePasscode(passcode: any) {
    this.passcode = passcode;
    if (passcode.length === 6) {
      this.enableVerifyAndContinue = true;
    } else {
      this.enableVerifyAndContinue = false;
    }
  }


  numberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  encryptValue(data: string) {
    return btoa(data);
  }

  openTermsAndConditionModal(value: any,url: string) {
    // Redirect to the external siteURL
    window.open(url, '_blank');
    // this.service.open(value);
  }

  carouselActive(event: Event) {
    const clickedBullet = event.target as HTMLLabelElement;
    const allBullets = document.querySelectorAll('.carousel-bullet');
    if (!(clickedBullet.classList[0] == 'carousel-indicators')) {
      allBullets.forEach((bullet) => {
        bullet.classList.remove('active');
      });
      clickedBullet.classList.add('active');
    }
  }

  isOverlayVisible = false;

  closeOverlay() {
    this.isOverlayVisible = false;
  }

  payloadForEmail: any;
  totalLoginAttempts: number = 5;
  attemptedCount: number = 0;
  isUserTriesLogin: boolean;

  enablePasswordForm() {
    this.setPasswordForm = this._formBuilder.group(
      {
        password: ['', [Validators.required, this.passwordPolicyValidator]],
        confirmPassword: ['', Validators.required],
        otp: [''], // if you want to store OTP in form
        // termsAccepted:[false,Validators.required],
        privacyAccepted:[false,Validators.required]
      },
      {
        validators: this.passwordMatchValidator.bind(this),
      }
    );

    this.phoneOtpRequired = false;
    this.emailOtpRequired = true;
  }


  removeReadonly(event: any) {
    event.target.removeAttribute('readonly');
  }

  termsAndConditionsChecked: boolean;
  privacyPolicyChecked: boolean;

  // Commented Code as Privacy Policy and Terms and Conditions links are now opening in new tab instead of modal
  // checkBoxTermsAndConditions(event) {
  //   this.termsAndConditionsChecked = event.target.checked;
  // }

  checkBoxPrivacyPolicy(event) {
    this.privacyPolicyChecked = event.target.checked;
  }

  isPhoneOtpOnMail: boolean = false;
  isStaticOtp: boolean = false;
  isStaticOtpEmail: boolean = false;
  staticOtpValue = environment.STATIC_OTP;
  isBothUnreachable: boolean = false;
  isStaticFromPhone = false;
  isStaticFromEmail = false;

  onChangePasscodeForForgotPassword(passcode: any) {
    this.passcode = passcode;
    if (passcode.length === 6) {
      this.enableVerifyAndContinue = true;
      this.setPasswordForm.patchValue({ otp: this.passcode });
    } else {
      this.enableVerifyAndContinue = false;
    }
  }

  changeCredForOtp() {
    this.forgotPasswordFormState = false;
    this.enableStepEmail = true;
    this.setPasswordForm.reset();
    this.enableVerifyAndContinue = false;
  }

  emailOtpRequired = true;
  phoneOtpRequired = true;

  emailVerified = false;
  phoneVerified = false;

  email = '';
  mobile = '';

  showOtpVerification = false;

  // For timers
  emailTimeLeft = 30;
  phoneTimeLeft = 30;

  // For enabling verify buttons
  emailEnableVerify = false;
  phoneEnableVerify = false;

  emailOtp = '';
  phoneOtp = '';

  signupFormPayload: any;
  isPhoneOtpOnMailSignup = false;
  isSignUpStaticOtp = false;
  isSignUpStaticOtpEmail = false;
  staticSignUpOtpValue = environment.STATIC_OTP;

  startEmailTimer() {
    this.emailTimeLeft = 30;
    const interval = setInterval(() => {
      this.emailTimeLeft--;
      if (this.emailTimeLeft <= 0) clearInterval(interval);
    }, 1000);
  }

  startPhoneTimer() {
    this.phoneTimeLeft = 30;
    const interval = setInterval(() => {
      this.phoneTimeLeft--;
      if (this.phoneTimeLeft <= 0) clearInterval(interval);
    }, 1000);
  }

  onEmailOtpChange(otp: string) {
    this.emailOtp = otp;
  }

  onPhoneOtpChange(otp: string) {
    this.phoneOtp = otp;
  }

  allOtpVerified() {
    if (this.emailOtpRequired && !this.emailVerified) return false;
    if (this.phoneOtpRequired && !this.phoneVerified) return false;
    return true;
  }

  allOtpEntered() {
    if (this.emailOtpRequired && this.emailOtp.length !== this.config.length)
      return false;
    if (this.phoneOtpRequired && this.phoneOtp.length !== this.config.length)
      return false;

    return true;
  }

  completeSignUp() {
    this.loading = true;

    const payload = {
      phoneCode: '+91',
      mobileNumber: this.mobile,
      email: this.email,
      sendOtpWithEmail: this.emailOtpRequired,
      phoneOtp: this.phoneOtp,
      emailOtp: this.emailOtp,
      isPhoneOtpSent: this.phoneOtpRequired,
      userId:this.jsonDecodedData.userId
    };
        this._authService.verifyOtpForAVUser(payload).subscribe({
      next: (res:any) => {
        console.log(res);
        
        if (res.statusCode === HttpStatusCode.Ok) {
          this.toaster.success('Otp Verified successfully', 'Success');
          this.loggedInUserService.setLoggedInUser(
            LoggedInUserKeys.LOGGED_IN_USER,
            res.data
          );
          this.inviteToken = sessionStorage.getItem('token');
          this.enablePasswordForm()
          this.loading = false;
          this.addPasswordForm = true;
          this.emailOtpRequired = false;
          this.phoneOtpRequired = false;
          // this.handleNavigation(res.data);
        }
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
        this.toaster.error('Incorrect OTPs. Please try again.', 'Error');
      },
    });

    // this.service.verifySignUpOtp(payload).subscribe({
    //   next: (res) => {
    //     if (res.statusCode === HttpStatusCode.Ok) {
    //       this.toaster.success('Signup completed', 'Success');
    //       this.loggedInUserService.setLoggedInUser(
    //         LoggedInUserKeys.LOGGED_IN_USER,
    //         res.data
    //       );
    //       this.handleNavigation(res.data);
    //     }
    //     this.loading = false;
    //   },
    //   error: (err) => {
    //     this.loading = false;
    //     console.error(err);
    //     this.toaster.error('Incorrect OTPs. Please try again.', 'Error');
    //   },
    // });
    // this.enablePasswordForm()
    // this.loading = false;
    // this.addPasswordForm = true;
    // this.emailOtpRequired = false;
    // this.phoneOtpRequired = false;
  }

  resendEmailOtp() {
    // const formData = this.signUpForm.value;
    this.loading = true;
    let payload = {
      // fullName: formData.username,
      email: this.email,
      mobileNumber: this.mobile,
      phoneCode: '+91',
      userId:this.jsonDecodedData.userId,
      secret:this.jsonDecodedData.secret,
      // privacyPolicyChecked: formData.privacyAccepted,
      // termsAndConditionsChecked: formData.termsAccepted,
      otpFor: 'EMAIL',
      userSource: 'ANALYTICS_VIDHYA'
    };

    this.service.generateSignUpOtp(payload).subscribe({
      next: () => {
        this.loading = false;
        this.startEmailTimer();
        this.toaster.success('Email OTP sent again', 'Success');
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  resendPhoneOtp() {
    // const formData = this.signUpForm.value;
    this.loading = true;
    let payload = {
      // fullName: formData.username,
      email: this.email,
      mobileNumber: this.mobile,
      phoneCode: '+91',
      userId:this.jsonDecodedData.userId,
      secret:this.jsonDecodedData.secret,
      // privacyPolicyChecked: formData.privacyAccepted,
      // termsAndConditionsChecked: formData.termsAccepted,
      otpFor: 'PHONE',
      userSource: 'ANALYTICS_VIDHYA'
    };

    this.service.generateSignUpOtp(payload).subscribe({
      next: () => {
        this.loading = false;
        this.startPhoneTimer();
        this.toaster.success('Mobile OTP sent again', 'Success');
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }


  showPassword: boolean = false;
  showPasswordSignup: boolean = false;
  showPasswordSignupConfirm: boolean = false;
  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  showPasswordForgotPassword: boolean = false;
  showPasswordForgotPasswordConfirm: boolean = false;
  togglePasswordForgotPassword() {
    this.showPasswordForgotPassword = !this.showPasswordForgotPassword;
  }

  togglePasswordForgotPasswordConfirm() {
    this.showPasswordForgotPasswordConfirm =
      !this.showPasswordForgotPasswordConfirm;
  }

  passwordPolicyValidator(control: AbstractControl) {
    const value = control.value || '';

    const errors: any = {};

    if (value.length < 8) {
      errors.minLength = true;
    }
    if (!/[A-Z]/.test(value)) {
      errors.uppercase = true;
    }
    if (!/[a-z]/.test(value)) {
      errors.lowercase = true;
    }
    if (!/[0-9]/.test(value)) {
      errors.number = true;
    }
    if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(value)) {
      errors.special = true;
    }

    return Object.keys(errors).length ? errors : null;
  }
  customNameValidations(
    control: AbstractControl
  ): { [key: string]: any } | null {
    const value = control.value || '';
    const specialCharRegex = /[^A-Za-z\s]/;
    const nameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;
    // Check if empty
    if (!value || value.trim().length === 0) {
      return { emptyName: true };
    } else if (specialCharRegex.test(value)) {
      return { specialCharacters: true };
    }

    // Check for multiple consecutive spaces
    // if (/\s{2,}/.test(value)) {
    //   return { multipleSpaces: true };
    // }
    else if (value !== value.trim()) {
      return { extraSpaces: true };
    }

    // Check for valid name pattern (must start and end with letters)
    else if (!nameRegex.test(value.trim())) {
      return { invalidName: true };
    }

    return null;
  }

  remainingLoginAttempts() {
    const remaining = this.totalLoginAttempts - this.attemptedCount;
    return remaining > 0 ? remaining : 0;
  }

  passwordMatchingValidatior: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');
    return password?.value === confirmPassword?.value
      ? null
      : { notmatched: true };
  };

  passwordValidator(control: AbstractControl): ValidationErrors | null {
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*()_+])[\w!@#$%^&*()_+]{8,}$/;
    if (!passwordPattern.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  resendOtpForForgotPassword() {
    this.loading = true;
    this.service.forgotPasswordRequest(this.payloadForEmail).subscribe({
      next: (response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          sessionStorage.setItem('SSO_LOGIN', 'false');
          this.toaster.success('OTP resent successfully', 'Success');
          this.startTimer();
        } else {
          this.toaster.error(response.message, 'Error');
        }
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  resetPassword(value:any) {
    this.loading = true;
    let payload: any = {};
   
    payload.email = this.email;
    payload.oldPassword = this.service.encryptValue('Fractal@123');
    payload.newPassword = this.service.encryptValue(value.password);
    payload.confirmPassword = this.service.encryptValue(value.confirmPassword);
    payload.isFromAV=true;
       this._adminService.candidateChangePassword(payload).subscribe({
        next: (response:any) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            this.toaster.success('Password changed successfully', 'success');
            this.loading = false;
            this.addPasswordForm = false;
            const userData=this.loggedInUserService.getLoggedInUser(
              LoggedInUserKeys.LOGGED_IN_USER,
            );
            // this.handleNavigation(userData);
            this.router.navigate([this.service.Navigations.DASHBOARD_ASSESSMENT]);
          }
          this.loading=false;
        },
        error: (error) => {
              console.error(error);
              this.loading = false;
            },
       })
    
    // this.service.forgotPasswordOtpVerify(payload).subscribe({
    //   next: (response) => {
    //     this.loading = false;

    //     this.toaster.success('Password reset successful', 'Success');
    //     this.forgotPasswordFormState = false;
    //     this.enableStepEmail = false;
    //     this.isUserTriesLogin = false;
    //   },
    //   error: (error) => {
    //     console.error(error);
    //     this.loading = false;
    //   },
    // });
  }

  handleNavigation(userData: any) {
    const {
      isFirstTimeLogin,
      isProfileDetailsUpdated,
      isProfileDetailsSkipped,
      hasRegisteredDrives,
    } = userData;

    const profileCompleted = isProfileDetailsUpdated;

    if (isFirstTimeLogin) {
    return  this.router.navigate([this.service.Navigations.NEW_PROFILE_DETAILS]);
      // this.router.navigate([this.service.Navigations.BASIC_DETAILS]);
    } else if (!profileCompleted) {
     return this.router.navigate([this.service.Navigations.NEW_PROFILE_DETAILS]);
    } else if (hasRegisteredDrives && !this.inviteToken) {
     return this.router.navigate([this.service.Navigations.DASHBOARD_ASSESSMENT]);
    } else if (hasRegisteredDrives && this.inviteToken) {
    return  this.navigateToInvite();
    } else if (!hasRegisteredDrives && !this.inviteToken) {
    return  this.router.navigate([this.service.Navigations.DASHBOARD]);
    } else if (!hasRegisteredDrives && this.inviteToken) {
    return  this.navigateToInvite();
    }
  }
  navigateToInvite() {
    this.router.navigate(['/examination/test/invite'], {
      queryParams: { token: this.inviteToken },
    });
  }

  bas64Decode(): void {
    this.loading = true;
    this.route.queryParams.subscribe( async params => {
      const base64Data = params['data'];
      if (base64Data) {
        try {
          const decodedData = JSON.parse(atob(base64Data));

          const { userId, ...rest } = decodedData;

          this.jsonDecodedData = {
            userId: userId,
            ...rest
          };
          if(this.jsonDecodedData && this.jsonDecodedData.driveId){
            sessionStorage.setItem('inviteDriveId', this.jsonDecodedData.driveId);
          }
          console.log(this.jsonDecodedData, 'decodedJsonData');
          console.log('Parsed JSON:', this.jsonDecodedData);
          await this.getOTP();
        } catch (error) {
          this.toaster.error('Invalid User parameter', 'Error');
          this.router.navigate([this.service.Navigations.SIGN_IN]);
        }
      } else {
        this.router.navigate([this.service.Navigations.SIGN_IN]);
      }
    });
  }

  async getOTP() {
    try {
      console.log('OTP api calling');
      this.email = this.jsonDecodedData.email;
      this.mobile = this.jsonDecodedData.phone_number.replace(/^\+91/, '');
      const response:any = await firstValueFrom(this._authService.getOTPForAVUser(this.jsonDecodedData));
      if (response.statusCode === HttpStatusCode.Ok && response.data) {
        this.loading = false;
        console.log(response.data, 'response.data');
        this.toaster.success('OTP sent successfully', 'Success');
        this.emailOtpRequired = response?.data?.emailOtp || false;
        this.phoneOtpRequired = response?.data?.phoneOtp || false;
        this.isPhoneOtpOnMailSignup = response?.data?.phoneOtpOnMail === true;
        this.isSignUpStaticOtp = response?.data?.staticOtp === true;
        this.isSignUpStaticOtpEmail = response?.data?.staticOtpEmail === true;
        this.showOtpVerification = true;
        this.startEmailTimer();
        this.startPhoneTimer();
      } else {
        this.loading = false;
        this.phoneTimeLeft=0;
        this.emailTimeLeft=0;
        this.toaster.error(response.message, 'Error');
      }
    } catch (error) {
      this.loading = false;
      this.phoneTimeLeft=0;
      this.emailTimeLeft=0;
      // if (error.status === 400 && error.error?.message === 'User not found') {
        this.router.navigate([this.service.Navigations.SIGN_IN]);
        // return;
      // }
      console.error(error);
    }
  }
}
